import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';


@Component({
    selector: 'app-hierarchy-of-locations-tree',
    templateUrl: './hierarchy-of-locations-tree.component.html',
    styles: [
        `.popup-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; }

.popup-content { background: white; padding: 20px; border-radius: 8px; position: relative; width: 300px; } .close-icon { position: absolute; top: 10px; right: 15px; cursor: pointer; font-size: 20px; }

.header-position { text-align: left; cursor: move;}

.font-weight-bold { font-weight: bolder; }

.timeout-modal { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(58, 90, 120, 0.7); display: flex; justify-content: center; align-items: center; z-index: 999; }

.modal-content { position: relative; background-color: white; border-top: 6px solid #b6d3e9; padding: 20px; width: 800px; max-width: 47%; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); border-radius: 8px; } h2 { font-size: 1.5em; font-weight: 500; border-bottom: 1px solid rgb(209 209 209); padding-bottom: 5px; margin-bottom: 10px; }

.close-icon { position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 20px;

  cursor: pointer; color: #888; } .mrtb{ margin-top:13pxpx }`
    ],
    standalone: false
})
export class HierarchyOfLocationsTreeComponent implements OnChanges {
    @Input() addFormType: string = '';
    @Input() typedLocation: string;
    @Input() selectedLocationIdentifier: string = 'alternateOrganizationUnitId';
    @Input() hierarchyOfLocationsData: any = [];
    @Input() selectedLevel: number = 0;
    @Input() preselectedIds: string[] = [];
    @Input() isReportsEditCopyMode: boolean = false;
    @Input() defaultRemovedLocations: { organizationUnitId: string }[] = [];
    @Input() oshaHol: string = ''
    @Input() hasBurst: boolean;
    @Input() isExpanded: boolean;

    @Output() locationSelected = new EventEmitter<any>();
    @Output() accountSelected = new EventEmitter<any>();
    @Output() locationsChecked = new EventEmitter<any[]>();
    @Output() levelAllLocationsChecked = new EventEmitter<any[]>();
    @Output() locationFromLevelUnchecked = new EventEmitter<any>();
    @Output() editLocation = new EventEmitter<any>();
    @Output() singleLocationChecked = new EventEmitter<any>();
    @Output() allExpandedChange = new EventEmitter<boolean>();
    @Output() nodeExpanded = new EventEmitter<any>();


    accountIndexTemp: number[] = [];
    checkedLocations: any[] = [];
    checkedSiblingLocationsTemp: any[] = [];
    indexTemp: number = -1;
    checkedLevelLocations: any[] = [];

    selectedIcon: any = {}
    showModal: boolean = false;
    public JSON = JSON;
    close() {
        this.showModal = false;
    }
    removeLastHyphen(str: string): string {
        const lastHyphenIndex = str.lastIndexOf('-');
        if (lastHyphenIndex !== -1) {
            return str.slice(0, lastHyphenIndex) + str.slice(lastHyphenIndex + 1);
        }
        return str;
    }
    establishmentInfo(location) {
        // let name = this.removeLastHyphen(location.locationName.split(location.locationCode)[0])
        this.selectedIcon['name'] = location?.estabName
        this.selectedIcon['address'] = location?.fullAddress
        this.showModal = true
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedLocationIdentifier) {
            this.selectedLocationIdentifier = changes.selectedLocationIdentifier.currentValue;
            this.expandBranchContainingSelectedLocation(this.hierarchyOfLocationsData, this.selectedLocationIdentifier);
        }
        if (changes.typedLocation?.currentValue) {
            this.onRadioButtonSelectionChange(changes.typedLocation.currentValue);
        }
        if (changes.selectedLevel?.currentValue && this.hierarchyOfLocationsData.length) {
            this.checkedLevelLocations = [];
            this.selectedLevel = +changes.selectedLevel.currentValue;
            this.setCheckedBySelectedLevel(this.selectedLevel, this.hierarchyOfLocationsData);
        }
        if (this.defaultRemovedLocations?.length && changes.selectedLevel?.currentValue && this.isReportsEditCopyMode) {
            this.removeDefaultLocations(this.defaultRemovedLocations);
        }
    }

    public checkLocationsByIds(ids: string[]) {
        // Clear existing checked locations since we're setting initial state
        this.checkedLocations = [];
        
        const markChecked = (locations: any[]) => {
            locations.forEach((location) => {
                const matchesOrgId = ids.includes(location.organizationUnitId);
                const matchesAltId = ids.includes(location.alternateOrganizationUnitId);
                if (matchesOrgId || matchesAltId) {
                    location.checked = true;
                    this.updateChildCheckStatus(location, true);
                    
                    // Add directly to checkedLocations without parent consolidation
                    if (!this.checkedLocations.some(node => node.organizationUnitId === location.organizationUnitId)) {
                        this.checkedLocations.push(location);
                    }

                    // Expand the branch to make it visible
                    this.expandBranchContainingSelectedLocation(
                        this.hierarchyOfLocationsData,
                        location.alternateOrganizationUnitId
                    );
                }
                if (location.childLocations?.length) {
                    markChecked(location.childLocations);
                }
            });
        };

        markChecked(this.hierarchyOfLocationsData);
        
        // After marking all checked locations, update parent check statuses
        const updateAllParents = (locations: any[]) => {
            locations.forEach((location) => {
                if (location.childLocations?.length) {
                    updateAllParents(location.childLocations);
                    // Check if all children are checked
                    const allChildrenChecked = location.childLocations.every((child: any) => child.checked);
                    if (allChildrenChecked) {
                        location.checked = true;
                    }
                }
            });
        };
        
        updateAllParents(this.hierarchyOfLocationsData);
        this.refineAndEmitCheckedLocations();
    }

    onRadioButtonSelectionChange(selectedLocation: any) {
        this.locationSelected.emit(selectedLocation);
    }

    onRowClicked(expanded: any, accountIndex: number) {
        if (this.hierarchyOfLocationsData.length > 1 && expanded === true) {
            this.accountIndexTemp.push(accountIndex);
            this.accountSelected.emit(accountIndex);
        } else if (
            this.hierarchyOfLocationsData.length > 1 &&
            expanded === false &&
            !this.hierarchyOfLocationsData.every((row) => row.expanded === false)
        ) {
            this.accountIndexTemp = this.accountIndexTemp.filter((index) => index !== accountIndex);
            this.accountSelected.emit(this.accountIndexTemp[this.accountIndexTemp.length - 1]);
        } else if (
            this.hierarchyOfLocationsData.length > 1 &&
            expanded === false &&
            this.hierarchyOfLocationsData.every((row) => row.expanded === false)
        ) {
            this.accountSelected.emit(0);
            this.accountIndexTemp = [];
        }
    }

    onCheckboxSelectionChange(location: any, checked: boolean) {
        location.checked = checked;
        this.updateChildCheckStatus(location, checked);
        this.updateParentCheckStatus(location);
        if (checked) {
            this.captureCheckedLocations(location);
        } else {
            this.removeUncheckedLocation(location);
        }
    }

    private updateChildCheckStatus(location: any, checked: boolean) {
        if (location.childLocations && location.childLocations.length) {
            location.childLocations.forEach((child: any) => {
                child.checked = checked;
                this.updateChildCheckStatus(child, checked);
            });
        }
    }

    private updateParentCheckStatus(location: any) {
        if (location.parentLocation) {
            const parentLocation = location.parentLocation;
            const allChildrenChecked = parentLocation.childLocations.every((child: any) => child.checked);
            parentLocation.checked = allChildrenChecked;
            this.updateParentCheckStatus(parentLocation);
        }
    }

    private captureCheckedLocations(location: any) {
        console.log('[Tree] captureCheckedLocations called for:', location.locationName, location.organizationUnitId);
        
        // Add the checked node itself to the list
        if (!this.checkedLocations.some((existingNode) => existingNode.organizationUnitId === location.organizationUnitId)) {
            this.checkedLocations.push(location);
            console.log('[Tree] Added node to checkedLocations');
        }
        
        this.refineAndEmitCheckedLocations();
    }

    private captureCheckedSiblingLocations(location: any) {
        let checkedSiblingLocations = [];
        if (location.parentLocation && location.parentLocation.childLocations) {
            const siblingLocations = location.parentLocation.childLocations;
            siblingLocations.forEach((sibling: any) => {
                if (
                    sibling.checked &&
                    !this.checkedLocations.some((node) => node.organizationUnitId === sibling.organizationUnitId)
                ) {
                    checkedSiblingLocations.push(sibling);
                }
            });
        }
        return checkedSiblingLocations;
    }

    private findLastCheckedParent(location: any): any {
        let currentLocation = location;
        while (currentLocation.parentLocation && currentLocation.parentLocation.checked) {
            currentLocation = currentLocation.parentLocation;
        }
        return currentLocation;
    }

    private removeRedundantChildLocations(parentNode: any) {
        if (parentNode.childLocations && parentNode.childLocations.length) {
            parentNode.childLocations.forEach((child: any) => {
                this.checkedLocations = this.checkedLocations.filter(
                    (node) => node.organizationUnitId !== child.organizationUnitId
                );
                this.removeRedundantChildLocations(child);
            });
        }
    }

    private removeUncheckedLocation(location: any) {
        console.log('[Tree] removeUncheckedLocation called for:', location.locationName);
        
        // Remove this location itself
        this.checkedLocations = this.checkedLocations.filter(
            (node) => node.organizationUnitId !== location.organizationUnitId
        );
        
        // If this is a parent node, also remove all its descendants
        if (location.childLocations && location.childLocations.length) {
            console.log('[Tree] Removing all descendants of unchecked parent');
            const removeDescendants = (node: any) => {
                if (node.childLocations) {
                    node.childLocations.forEach((child: any) => {
                        this.checkedLocations = this.checkedLocations.filter(
                            (n) => n.organizationUnitId !== child.organizationUnitId
                        );
                        removeDescendants(child);
                    });
                }
            };
            removeDescendants(location);
        }
        
        this.removeRedundantParentLocations(location);
        this.refineAndEmitCheckedLocations();
    }

    private removeRedundantParentLocations(location: any) {
        if (location.parentLocation) {
            const parentLocation = location.parentLocation;
            const allChildrenChecked = parentLocation.childLocations.every((child: any) => child.checked);
            if (!allChildrenChecked) {
                this.indexTemp =
                    this.indexTemp === -1
                        ? this.checkedLocations.findIndex(
                            (node) => node.organizationUnitId === parentLocation.organizationUnitId
                        )
                        : this.indexTemp;
                this.checkedLocations = this.checkedLocations.filter(
                    (node) => node.organizationUnitId !== parentLocation.organizationUnitId
                );
                this.checkedSiblingLocationsTemp.unshift(...this.captureCheckedSiblingLocations(location));
                this.removeRedundantParentLocations(parentLocation);
            }
        }
        if (this.checkedSiblingLocationsTemp.length && this.indexTemp !== -1)
            this.checkedLocations.splice(
                this.indexTemp,
                0,
                ...this.rearrangeCheckedLocations(this.checkedSiblingLocationsTemp, this.hierarchyOfLocationsData)
            );
        this.checkedSiblingLocationsTemp = [];
        this.indexTemp = -1;
    }

    private findAllCheckedLocations(locations: any[]): any[] {
        let tempCheckedLocations: any[] = [];
        locations.forEach((location) => {
            if (location.checked) {
                tempCheckedLocations.push(location);
            }
            if (location.childLocations && location.childLocations.length) {
                tempCheckedLocations = tempCheckedLocations.concat(
                    this.findAllCheckedLocations(location.childLocations)
                );
            }
        });
        return tempCheckedLocations;
    }

    refineAndEmitCheckedLocations() {
        console.log('[Tree] refineAndEmitCheckedLocations - checkedLocations before:', this.checkedLocations);
        
        // Collect all checked nodes from the entire tree hierarchy
        this.checkedLocations = this.findAllCheckedLocations(this.hierarchyOfLocationsData);
        console.log('[Tree] After findAllCheckedLocations:', this.checkedLocations);
        
        const finalCheckedLocations = this.checkedLocations.map((location) => {
            return {
                locationName: location.locationName,
                organizationUnitId: location.organizationUnitId,
                alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                locationCode: location.locationCode ? location.locationCode : '',
                level: location.level
            };
        });
        console.log('[Tree] Emitting finalCheckedLocations:', finalCheckedLocations);
        this.locationsChecked.emit(finalCheckedLocations);
    }

    private rearrangeCheckedLocations(checkedLocations: any[], hierarchyOfLocationsData: any[]): any[] {
        let orderedNodes: any[] = [];

        const flattenHierarchy = (locations: any[]) => {
            locations.forEach((location) => {
                if (checkedLocations.some((node) => node.organizationUnitId === location.organizationUnitId)) {
                    orderedNodes.push({
                        locationName: location.locationName,
                        organizationUnitId: location.organizationUnitId,
                        alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                        locationCode: location.locationCode ? location.locationCode : '',
                        level: location.level
                    });
                }
                if (location.childLocations && location.childLocations.length) {
                    flattenHierarchy(location.childLocations);
                }
            });
        };

        flattenHierarchy(hierarchyOfLocationsData);
        return orderedNodes;
    }

    private expandBranchContainingSelectedLocation(locations: any[], selectedLocationIdentifier: string): boolean {
        let found = false;
        for (let location of locations) {
            // Don't collapse - just expand if needed
            if (location.alternateOrganizationUnitId === selectedLocationIdentifier) {
                location.expanded = true;
                found = true;
            } else if (location.childLocations && location.childLocations.length) {
                const childFound = this.expandBranchContainingSelectedLocation(
                    location.childLocations,
                    selectedLocationIdentifier
                );
                if (childFound) {
                    location.expanded = true;
                    found = true;
                }
            }
        }
        return found;
    }

    setCheckedBySelectedLevel(selectedLevel: number, locations: any[]) {
        locations.forEach((location) => {
            location.checked = location.level === selectedLevel;
            if (location.checked) {
                this.checkedLevelLocations.push({
                    locationName: location.locationName,
                    organizationUnitId: location.organizationUnitId,
                    alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                    locationCode: location.locationCode ? location.locationCode : '',
                    level: location.level
                });
            }
            if (location.childLocations && location.childLocations.length) {
                this.setCheckedBySelectedLevel(selectedLevel, location.childLocations);
            }
        });
        this.levelAllLocationsChecked.emit(this.checkedLevelLocations);
    }

    onLevelCheckboxSelectionChange(location: any, checked: boolean) {
        if (checked) {
            const alreadyExists = this.checkedLevelLocations.some(
                (node) => node.organizationUnitId === location.organizationUnitId
            );
            if (!alreadyExists) {
                this.checkedLevelLocations.push({
                    locationName: location.locationName,
                    organizationUnitId: location.organizationUnitId,
                    alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                    locationCode: location.locationCode ? location.locationCode : '',
                    level: location.level
                });
            }
            this.singleLocationChecked.emit({
                locationName: location.locationName,
                organizationUnitId: location.organizationUnitId,
                alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                locationCode: location.locationCode ? location.locationCode : '',
                level: location.level
            })
        } else {
            this.checkedLevelLocations = this.checkedLevelLocations.filter(
                (node) => node.organizationUnitId !== location.organizationUnitId
            );
            this.locationFromLevelUnchecked.emit({
                locationName: location.locationName,
                organizationUnitId: location.organizationUnitId,
                alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                locationCode: location.locationCode ? location.locationCode : '',
                level: location.level
            });
        }
        this.locationsChecked.emit(this.checkedLevelLocations);
    }

    private removeDefaultLocations(defaultRemoved: { organizationUnitId: string }[]) {
        const idsToRemove = defaultRemoved.map(loc => loc.organizationUnitId);

        const traverseAndRemove = (locations: any[]) => {
            locations.forEach(location => {
                if (idsToRemove.includes(location.organizationUnitId) && location.level === this.selectedLevel) {
                    location.checked = false;

                    this.locationFromLevelUnchecked.emit({
                        locationName: location.locationName,
                        organizationUnitId: location.organizationUnitId,
                        alternateOrganizationUnitId: location.alternateOrganizationUnitId,
                        locationCode: location.locationCode || '',
                        level: location.level
                    });

                    this.checkedLevelLocations = this.checkedLevelLocations.filter(
                        node => node.organizationUnitId !== location.organizationUnitId
                    );
                }

                if (location.childLocations?.length) {
                    traverseAndRemove(location.childLocations);
                }
            });
        };

        traverseAndRemove(this.hierarchyOfLocationsData);

        this.locationsChecked.emit(this.checkedLevelLocations);

        this.checkedLevelLocations.forEach(loc => {
            this.singleLocationChecked.emit(loc);
        });
    }

    getLocationNameOnly(location) {
        return location.locationName.includes(`- ${location.locationCode}`)
            ? location.locationName.split(`- ${location.locationCode}`)[0].trim()
            : location.locationName;
    }

    onEditLocation(location: any): void {
        this.editLocation.emit(location);
    }

    public expandAll(): void {
        this.setExpansionRecursive(this.hierarchyOfLocationsData, true);
        this.allExpandedChange.emit(true);
    }

    public collapseAll(): void {
        this.setExpansionRecursive(this.hierarchyOfLocationsData, false);
        this.allExpandedChange.emit(false);
    }

    private setExpansionRecursive(locations: any[], expanded: boolean): void {
        for (const location of locations) {
            location.expanded = expanded;
            if (location.childLocations && location.childLocations.length > 0) {
                this.setExpansionRecursive(location.childLocations, expanded);
            }
        }
    }

    toggleNode(location: any): void {
        location.expanded = !location.expanded;
        if (location.expanded && location.childLocations?.length) {
            // this.setExpansionRecursive(location.childLocations, true);
            this.nodeExpanded.emit(location)
        }
        const allExpanded = this.checkIfAllExpanded();
        this.allExpandedChange.emit(allExpanded);
    }

    /**
     * Toggle node expansion for radioType mode with placeholder-aware delayed expansion
     * @param location - Node being toggled
     * @param accountIndex - Account index for selection tracking
     */
    toggleNodeRadio(location: any, accountIndex: number): void {
        // If collapsing, do it immediately
        if (location.expanded) {
            location.expanded = false;
            this.onRowClicked(false, accountIndex);
            return;
        }
        
        // If expanding and has placeholder children, emit event but DON'T expand yet
        // The parent component will expand after loading data
        if (location.childLocations?.length && location.childLocations[0]?._placeholder) {
            this.nodeExpanded.emit(location);
            this.onRowClicked(true, accountIndex);
            return;
        }
        
        // If expanding with real children, expand immediately
        location.expanded = true;
        if (location.childLocations?.length) {
            this.nodeExpanded.emit(location);
        }
        this.onRowClicked(true, accountIndex);
    }


    private checkIfAllExpanded(): boolean {
        return this.areAllExpanded(this.hierarchyOfLocationsData);
    }

    private areAllExpanded(locations: any[]): boolean {
        for (const location of locations) {
            if (!location.expanded) {
                return false;
            }
            if (location.childLocations && location.childLocations.length > 0) {
                if (!this.areAllExpanded(location.childLocations)) {
                    return false;
                }
            }
        }
        return true;
    }


}
